import styled from 'styled-components'
import { type CMSBadgeData } from '@/features/cms/components/CMS/types'
import { BadgeVariant, CustomBadge } from '@/features/shared/elements/Badges'
import { badgeStyle } from '@/features/shared/elements/Badges/config'

export const Badge = ({ badge }: { badge: CMSBadgeData }) => {
  const badgeConfig = badge.content && badgeStyle[badge.badge_type]
  if (!badgeConfig) return null
  return (
    <CMSCustomBadge
      color={badgeConfig.color}
      bgColor={badgeConfig.bgColor}
      variant={BadgeVariant.flag}
    >
      {badge.content}
    </CMSCustomBadge>
  )
}

const CMSCustomBadge = styled(CustomBadge)`
  position: absolute;
  top: -0.5rem;
  left: -0.5rem;
  z-index: 2;
`
